export const CONVERSATION_PREFIX = 'cnv' as const;
export const ID_GLUE = '_' as const;

export type ConversationId = `${typeof CONVERSATION_PREFIX}${typeof ID_GLUE}${string}`;
